module.exports = (__webpack_require__(3832))(40);